module.exports = __webpack_public_path__ + "static/img/nh.01191a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nh.jpg
// module id = KLTb
// module chunks = 1